"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Node = _interopRequireDefault(require("../node/Node"));

var _styles = require("../../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Tree =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Tree, _React$Component);

  function Tree() {
    _classCallCheck(this, Tree);

    return _possibleConstructorReturn(this, _getPrototypeOf(Tree).apply(this, arguments));
  }

  _createClass(Tree, [{
    key: "render",
    value: function render() {
      var _this = this;

      var data = this.props.data;

      var renderTree = function renderTree(tree, multiChild) {
        var _this$props = _this.props,
            classes = _this$props.classes,
            render = _this$props.render,
            onClick = _this$props.onClick,
            direction = _this$props.direction;
        var lines = classes.lines;
        return _react.default.createElement(_styles.Root, {
          styles: lines
        }, tree.map(function (branch) {
          var nextWithSingleChild = branch.children.length > 1;
          return _react.default.createElement(_Node.default, {
            item: branch,
            key: branch.id,
            onClick: onClick,
            classes: _objectSpread({}, classes),
            render: render,
            direction: direction,
            round: multiChild
          }, branch.children.length > 0 && renderTree(branch.children, nextWithSingleChild));
        }));
      };

      return renderTree(data, false);
    }
  }]);

  return Tree;
}(_react.default.Component);

Tree.propTypes = {
  classes: _propTypes.default.objectOf(_propTypes.default.object),
  data: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  render: _propTypes.default.func,
  onClick: _propTypes.default.func,
  direction: _propTypes.default.bool
};
Tree.defaultProps = {
  classes: {
    lines: {
      height: '60px',
      width: '2px'
    },
    node: {},
    text: {},
    arrow: {}
  },
  render: null,
  onClick: null,
  direction: false
};
var _default = Tree;
exports.default = _default;